import InspectionFormPage from './InspectionFormPage-redux';

export default InspectionFormPage;
